<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity="0.75"
      rounded="sm"
      :show="loadingPaymentMethods"
    >
      <b-card>
        <b-card-title><h2>Card Details</h2></b-card-title>
        <b-table
          responsive
          :fields="tableColumns"
          :items="paymentData"
          show-empty
          empty-text="No records found"
          class="mt-2"
        >
          <template #cell(created_at)="data">
            {{ data.item.created_at | formatDate }}
          </template>
          <template #cell(deleted)="data">
            {{ data.item.deleted ? 'Yes' : 'No' }}
          </template>
          <template #cell(card_type)="data">
            {{ snakeCaseToCamcelCaase(data.item.card_type) }}
          </template>
          <template #cell(customer_name)="data">
            {{ snakeCaseToCamcelCaase(data.item.customer_name) }}
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BCardTitle, BTable,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import snakeCaseToCamcelCaase from '@/utils/snake-case-to-camcel-caase'

export default {
  components: {
    BOverlay, BCard, BCardTitle, BTable,
  },
  props: {
    paymentMethodsData: {
      type: Object,
      default: () => { },

    },
    loadingPaymentMethods: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const tableColumns = [
      { key: 'card_type', label: 'Card Type' },
      { key: 'card', label: 'Card Number' },
      { key: 'customer_name', label: 'Customer Name' },
      { key: 'card_expiration_date', label: 'Expiry date' },
      { key: 'deleted', label: 'Is Deleted' },
      { key: 'created_at', label: 'Created At' },
    ]
    const paymentData = computed(() => {
      if (props.paymentMethodsData) {
        return props.paymentMethodsData.data.map(el => ({
          ...el,
          ...el.meta,
        }))
      }
      return []
    })

    return {
      paymentData,
      tableColumns,
      snakeCaseToCamcelCaase,
    }
  },
}
</script>
